import * as ComponentCopies from './components'
import * as InputCopies from './inputs'
import * as PageCopies from './pages'
import * as TouchablesCopies from './touchables'

export const Components = ComponentCopies
export const Inputs = InputCopies
export const Pages = PageCopies
export const Touchables = TouchablesCopies
